import { DesignProduct } from "../../util/Products";
import DesignProductCard from "./DesignProductCard";
import { useEffect, useRef, useState } from "react";
import "./DesignCarousel.scss";
import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

enum Direction {
  Left,
  Right,
}

const ScrollStep = 500;

export interface DesignCarouselProps {
  products: DesignProduct[];
}

export default function DesignCarousel({
  products
}: DesignCarouselProps) {
  const carousel = useRef<HTMLUListElement>(null);

  const [left, setLeft] = useState(false);
  const [right, setRight] = useState(true);

  useEffect(() => {
    if (!carousel || !carousel.current) return;

    if (carousel.current.scrollWidth <= carousel.current.clientWidth) {
      setRight(false);
    }

    const { current } = carousel;
    current.addEventListener("scroll", (ev) => {
      const width = current.clientWidth;
      const fullWidth = current.scrollWidth;
      const left = current.scrollLeft;

      setLeft(left > 0);
      setRight(width + left + 10 < fullWidth);
    });
  }, [carousel]);

  function scroll(dir: Direction) {
    if (!carousel || !carousel.current) return;
    const { current } = carousel;

    current.scroll({
      top: 0,
      left:
        dir === Direction.Left
          ? current.scrollLeft - ScrollStep
          : current.scrollLeft + ScrollStep,
      behavior: "smooth",
    });
  }

  return (
    <>
      <section className={"products-carousel"}>
        {left && (
          <Button
            className={"bt btn-left"}
            onClick={() => scroll(Direction.Left)}
          >
            <LeftOutlined />
          </Button>
        )}
        <ul ref={carousel}>
          {products.map((it) => (
            <DesignProductCard product={it} key={it.key} />
          ))}
        </ul>
        {right && (
          <Button
            className={"bt btn-right"}
            onClick={() => scroll(Direction.Right)}
          >
            <RightOutlined />
          </Button>
        )}
      </section>
    </>
  );
}
